<template>
  <div>
    <messageBox ref="msgBox" />
    <div v-if="loadingData">
      <v-row class="text-center" align="center" justify="center">
        <v-progress-circular
          :indeterminate="true"
          :rotate="0"
          :size="32"
          :width="4"
          color="light-blue"
        ></v-progress-circular>
      </v-row>
      <v-row class="text-center" align="center" justify="center">
        Caricamento in corso....
      </v-row>
    </div>

    <div v-if="!loadingData">
      <v-row
        v-if="!this.$store.state.editing"
        class="form-title"
        align="center"
        justify="center"
        ><h2 class="header-title-h2">
          I suoi servizi sono stati selezionati.
        </h2></v-row
      >
      <v-row
        v-if="!this.$store.state.editing"
        class="form-title"
        align="center"
        justify="center"
      >
        <h3>
          Per ultimare l'aspetto grafico del suo sito , ed i suoi contenuti, è
          necessario caricare alcune immagini ed inserire dei testi. Ci siamo
          permessi di pre-configurare alcuni campi con dei valori generici in
          modo da permetterle di inserire i suoi contenuti in un momento
          successivo.
        </h3></v-row
      >
    </div>

    <v-row
      v-if="!loadingData"
      class="text-center"
      align="center"
      justify="center"
    >
      <v-btn @click="showPreview()" color="#b083a8" class="white--text">
        ANTEPRIMA
      </v-btn>
    </v-row>

    <v-row
      v-if="!loadingData"
      class="text-center"
      align="center"
      justify="center"
    >
      <v-col>
        <v-stepper v-model="e6" class="side-stepper" vertical>
          <v-stepper-step :complete="e6 > 1" step="1" :editable="true">
            Informazioni
            <small>Dettagli principali del suo sito web</small>
          </v-stepper-step>

          <v-stepper-content class="vertical-stepper-content" step="1">
            <v-card color="#ffffff" class="ma-1 pb-2 elevation-4 card-contents">
              <v-row class="form-title" align="center" justify="center"
                ><v-col>
                  <div class="input-container d-flex align-center">
                    <v-checkbox
                      class="image_description"
                      v-model="meta.enable_logo"
                      label="Attiva logo barra superiore"
                    >
                    </v-checkbox>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          class="ml-2"
                          color="#74a2bc"
                          v-bind="attrs"
                          v-on="on"
                          slot="activator"
                          >mdi-information-outline</v-icon
                        ></template
                      >
                      <span
                        >Mostra il logo selezionato sulla destra, nella barra
                        superiore del tuo sito</span
                      >
                    </v-tooltip>
                  </div>

                  <v-checkbox
                    v-model="meta.enable_doctor_name_top_bar"
                    label="Attiva nome dottore barra superiore"
                  >
                  </v-checkbox>

                  <v-checkbox
                    v-model="meta.enable_social_bar"
                    label="Attiva elenco social"
                  >
                  </v-checkbox>
                </v-col>
                <v-col>
                  <p class="image_description">Logo barra superiore</p>
                  <picture-input
                    ref="logo_selector"
                    width="64"
                    height="64"
                    margin="4"
                    size="1"
                    accept="image/jpeg,image/png"
                    button-class="primary"
                    :hideChangeButton="true"
                    :removable="false"
                    :custom-strings="logoCustomString"
                    @change="onChangeImage('logo')"
                    @ready="onReadyImage('logo')"
                  >
                  </picture-input>
                  <p class="image_description">
                    Click per caricare la tua immagine<BR />o scegli tra i
                    predefiniti nella barra sottostante
                  </p>

                  <ImagesStripeView
                    width="380"
                    height="58"
                    thumbWidth="48"
                    thumbHeight="48"
                    scope="logos"
                    type="logo"
                    style="border:1px solid #aaaaaa;"
                    @selected="imageSelected($event, 'logo')"
                  />
                </v-col>
              </v-row>
              <v-row class="form-title" align="center" justify="center">
                <v-col> </v-col>
              </v-row>
              <v-btn
                v-if="!$store.state.editing"
                color="primary"
                @click="setContentsStep(2)"
              >
                PASSO SUCCESSIVO
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" step="2" :editable="true">
            Slides
            <small
              >Configura i testi e le foto delle slides della tua home
              page</small
            >
          </v-stepper-step>

          <ValidationObserver ref="obs2" v-slot="{ invalid, validated }">
            <v-stepper-content class="vertical-stepper-content" step="2">
              <v-card
                color="#ffffff"
                class="ma-1 pb-2 elevation-4 card-contents"
              >
                <v-row class="form-title" align="center" justify="center"
                  ><v-col cols="12">
                    <ValidationProvider
                      rules="max:50|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                    >
                      <v-text-field
                        v-model="meta.slide_1_title"
                        :error-messages="errors"
                        :success="valid"
                        outlined
                        label="Titolo slide 1"
                        required
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      rules="max:50|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                    >
                      <v-text-field
                        v-model="meta.slide_1_text"
                        :error-messages="errors"
                        :success="valid"
                        label="Descrizione slide 1"
                        required
                        outlined
                      />
                    </ValidationProvider> </v-col
                  ><v-col cols="12">
                    <p class="image_description">
                      Click per caricare una tua foto
                    </p>
                    <picture-input
                      ref="slide_1_selector"
                      width="100"
                      height="90"
                      margin="0"
                      size="4"
                      accept="image/jpeg,image/png"
                      button-class="primary"
                      :hideChangeButton="true"
                      :removable="false"
                      style="border:1px solid #aaaaaa; width: 90px; height: 80px;"
                      :custom-strings="slideCustomString"
                      @change="onChangeImage('slide_1')"
                      @ready="onReadyImage('slide_1')"
                    >
                    </picture-input>
                  </v-col>
                  <v-col cols="12">
                    <p class="image_description">
                      Scegli facendo scroll da più di 40 foto predefinite o fai
                      click per caricarne una tua.
                    </p>
                    <ImagesStripeView
                      width="400"
                      height="90"
                      thumbWidth="100"
                      thumbHeight="80"
                      scope="slides"
                      type="slide_1"
                      style="border:1px solid #aaaaaa;"
                      @selected="imageSelected($event, 'slide_1')"
                    />
                  </v-col>
                </v-row>

                <v-row class="form-title" align="center" justify="center"
                  ><v-col cols="12">
                    <ValidationProvider
                      rules="max:50|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                      ><v-text-field
                        v-model="meta.slide_2_title"
                        label="Titolo slide 2"
                        required
                        outlined
                        :error-messages="errors"
                        :success="valid"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      rules="max:50|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                      ><v-text-field
                        v-model="meta.slide_2_text"
                        label="Descrizione slide 2"
                        required
                        outlined
                        :error-messages="errors"
                        :success="valid"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <p class="image_description">
                      Click per caricare una tua foto
                    </p>
                    <picture-input
                      ref="slide_2_selector"
                      width="100"
                      height="90"
                      margin="0"
                      size="4"
                      accept="image/jpeg,image/png"
                      button-class="primary"
                      :hideChangeButton="true"
                      :removable="false"
                      style="border:1px solid #aaaaaa; width: 90px; height: 80px;"
                      :custom-strings="slideCustomString"
                      @change="onChangeImage('slide_2')"
                      @ready="onReadyImage('slide_2')"
                    >
                    </picture-input>
                  </v-col>
                  <v-col cols="12">
                    <p class="image_description">
                      Scegli facendo scroll da più di 40 foto predefinite o fai
                      click per caricarne una tua.
                    </p>
                    <ImagesStripeView
                      width="400"
                      height="90"
                      thumbWidth="100"
                      thumbHeight="80"
                      scope="slides"
                      type="slide_2"
                      style="border:1px solid #aaaaaa;"
                      @selected="imageSelected($event, 'slide_2')"
                    />
                  </v-col>
                </v-row>

                <v-row class="form-title" align="center" justify="center"
                  ><v-col cols="12">
                    <ValidationProvider
                      rules="max:50|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                    >
                      <v-text-field
                        v-model="meta.slide_3_title"
                        label="Titolo slide 3"
                        required
                        :error-messages="errors"
                        :success="valid"
                        outlined
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      rules="max:50|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                    >
                      <v-text-field
                        v-model="meta.slide_3_text"
                        label="Descrizione slide 3"
                        required
                        :error-messages="errors"
                        :success="valid"
                        outlined
                    /></ValidationProvider> </v-col
                  ><v-col cols="12">
                    <p class="image_description">
                      Click per caricare una tua foto
                    </p>
                    <picture-input
                      ref="slide_3_selector"
                      width="100"
                      height="90"
                      margin="0"
                      size="4"
                      accept="image/jpeg,image/png"
                      button-class="primary"
                      :hideChangeButton="true"
                      :removable="false"
                      style="border:1px solid #aaaaaa; width: 90px; height: 80px;"
                      :custom-strings="slideCustomString"
                      @change="onChangeImage('slide_3')"
                      @ready="onReadyImage('slide_3')"
                    >
                    </picture-input>
                  </v-col>
                  <v-col cols="12">
                    <p class="image_description">
                      Scegli facendo scroll da più di 40 foto predefinite o fai
                      click per caricarne una tua.
                    </p>
                    <ImagesStripeView
                      width="400"
                      height="90"
                      thumbWidth="100"
                      thumbHeight="80"
                      scope="slides"
                      type="slide_3"
                      style="border:1px solid #aaaaaa;"
                      @selected="imageSelected($event, 'slide_3')"
                    />
                  </v-col>
                </v-row>

                <v-btn
                  v-if="!$store.state.editing"
                  :disabled="invalid || !validated"
                  color="primary"
                  @click="setContentsStep(3)"
                >
                  PASSO SUCCESSIVO
                </v-btn>
              </v-card>
            </v-stepper-content>
          </ValidationObserver>

          <v-stepper-step :complete="e6 > 3" step="3" :editable="true">
            Profilo personale
            <small>Carica le tue foto e descrivi la tua attività</small>
          </v-stepper-step>

          <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
            <v-stepper-content class="vertical-stepper-content" step="3">
              <v-card
                color="#ffffff"
                class="ma-1 pb-2 elevation-4 card-contents"
              >
                <v-row class="form-title" align="center" justify="center">
                  <v-col
                    ><h4>
                      Carica delle foto che saranno inserita nella descrizione
                      del tuo profilo e nei tuoi servizi, o selezionale fra
                      quelle disponibili!
                    </h4></v-col
                  ></v-row
                >

                <v-row class="form-title" align="start" justify="center">
                  <v-col>
                    <ValidationProvider
                      rules="max:40|min:1"
                      v-slot="{ errors, valid }"
                      immediate
                    >
                      <v-text-field
                        v-model="meta.name"
                        label="Nome"
                        :error-messages="errors"
                        :success="valid"
                        required
                        outlined
                      />
                    </ValidationProvider>

                    <v-text-field
                      v-model="meta.specialization"
                      label="Specializzazione"
                      required
                      outlined
                    >
                    </v-text-field>

                    <v-text-field
                      v-model="meta.specialization_subtitle"
                      label="Sottotitolo specializzazione"
                      required
                      outlined
                    >
                    </v-text-field>

                    <p class="image_description">
                      Click per caricare la tua foto personale o scegli da
                      quelle predefinite
                    </p>

                    <picture-input
                      ref="profile_selector"
                      width="200"
                      height="200"
                      margin="0"
                      accept="image/jpeg,image/png"
                      size="4"
                      style="border:1px solid #aaaaaa; width: 200px; height: 200px;"
                      button-class="primary"
                      :hideChangeButton="true"
                      :removable="false"
                      :custom-strings="imageCustomStrings"
                      @change="onChangeImage('profile')"
                      @ready="onReadyImage('profile')"
                    >
                    </picture-input>
                    <br />
                    <ImagesStripeView
                      width="600px"
                      height="100px"
                      thumbWidth="100"
                      thumbHeight="100"
                      scope="docs"
                      type="profile"
                      style="border:1px solid #aaaaaa;"
                      @selected="imageSelected($event, 'profile')"
                    />

                    <v-col>
                      <ValidationProvider
                        rules="max:1200"
                        v-slot="{ errors, valid }"
                        immediate
                      >
                        <v-textarea
                          v-model="meta.description"
                          label="Descrizione (max. 1200 caratteri)"
                          required
                          no-resize
                          outlined
                          height="220"
                          :error-messages="errors"
                          :success="valid"
                        >
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-col>
                </v-row>

                <v-btn
                  v-if="!$store.state.editing"
                  :disabled="invalid || !validated"
                  color="primary"
                  @click="setContentsStep(4)"
                >
                  PASSO SUCCESSIVO
                </v-btn>
              </v-card>
            </v-stepper-content>
          </ValidationObserver>

          <v-stepper-step step="4" :editable="true" :complete="e6 > 4">
            Pacchetti
            <small
              >Scegli i pacchetti che metti a disposizione per i tuoi
              clienti</small
            >
          </v-stepper-step>
          <v-stepper-content class="vertical-stepper-content" step="4">
            <v-card color="#ffffff" class="ma-1 pb-2 elevation-4 card-contents">
              <v-row class="form-title" align="center" justify="center"
                ><v-col>
                  <v-row class="form-title" align="center" justify="center"
                    ><v-col cols="12">
                      <v-text-field
                        v-model="meta.evidence_title"
                        label="Titolo in evidenza"
                        required
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="meta.evidence_text"
                        label="Testo in evidenza"
                        required
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      <p class="image_description">
                        Scegli facendo scroll da più di 40 foto predefinite o
                        fai click per caricarne una tua.<BR /> Aggiungi o
                        rimuovi pacchetti utilizzando il tasto
                        <v-icon color="green">mdi-plus</v-icon> o il tasto
                        <v-icon color="red">mdi-delete</v-icon> alla destra del
                        pacchetto
                      </p></v-col
                    >
                  </v-row>
                  <v-row
                    v-for="(item, index) in packets"
                    :key="index + 1"
                    class="form-title"
                    align="center"
                    justify="center"
                    ><v-col cols="12">
                      <v-text-field
                        v-model="meta['pack_' + (index + 1) + '_title']"
                        label="Titolo pacchetto"
                        required
                        outlined
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="meta['pack_' + (index + 1) + '_text']"
                        label="Descrizione pacchetto"
                        required
                        outlined
                      >
                      </v-text-field> </v-col
                    ><v-col cols="12">
                      <p class="image_description">Immagine pacchetto</p>
                      <picture-input
                        :ref="'pack_' + (index + 1) + '_selector'"
                        width="200"
                        height="80"
                        margin="4"
                        size="4"
                        accept="image/jpeg,image/png"
                        button-class="primary"
                        :hideChangeButton="true"
                        :removable="false"
                        style="border:1px solid #aaaaaa; width: 200px;"
                        :custom-strings="packCustomString"
                        @change="onChangeImage('pack_' + (index + 1))"
                        @ready="onReadyImage('pack_' + (index + 1))"
                      >
                      </picture-input>
                    </v-col>
                    <v-col cols="12">
                      <p class="image_description">Immagini predefinite</p>
                      <ImagesStripeView
                        width="400"
                        height="90"
                        thumbWidth="100"
                        thumbHeight="80"
                        scope="packs"
                        :type="'pack_' + (index + 1)"
                        style="border:1px solid #aaaaaa;"
                        @selected="imageSelected($event, 'pack_' + (index + 1))"
                      />

                      <v-col cols="12">
                        <v-btn v-if="index + 1 != 1" icon>
                          <v-icon @click="removePacket(index + 1)" color="red"
                            >mdi-delete</v-icon
                          >
                        </v-btn>

                        <v-btn icon v-if="index + 1 == meta.number_of_packets">
                          <v-icon @click="addPacket()" color="green"
                            >mdi-plus</v-icon
                          >
                        </v-btn>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-btn
                v-if="!$store.state.editing"
                color="primary"
                @click="setContentsStep(5)"
              >
                PASSO SUCCESSIVO
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-step step="5" :editable="true" :complete="e6 > 5">
            Servizi
            <small
              >Scrivi i testi e le foto per arricchire la sezione dei tuoi
              servizi</small
            >
          </v-stepper-step>
          <v-stepper-content class="vertical-stepper-content" step="5">
            <v-card color="#ffffff" class="ma-1 pb-2 elevation-4 card-contents">
              <v-row dense class="form-title" align="start" justify="center"
                ><v-col>
                  <v-text-field
                    v-model="meta.services_title"
                    label="Titolo in evidenza"
                    required
                    outlined
                  >
                  </v-text-field>

                  <ValidationProvider
                    rules="max:1200"
                    v-slot="{ errors, valid }"
                    immediate
                  >
                    <v-textarea
                      v-model="meta.services_description"
                      label="Testo in evidenza (max. 1200 caratteri)"
                      required
                      height="300"
                      outlined
                      :error-messages="errors"
                      :success="valid"
                    >
                    </v-textarea>
                  </ValidationProvider> </v-col
              ></v-row>
              <v-row dense class="form-title" align="start" justify="center">
                <v-col>
                  <p class="image_description">Foto servizi</p>
                  <picture-input
                    ref="services_selector"
                    width="300"
                    height="300"
                    margin="16"
                    accept="image/jpeg,image/png"
                    size="5"
                    button-class="primary"
                    :hideChangeButton="true"
                    :removable="false"
                    style="border:1px solid #aaaaaa; width:250px;"
                    :custom-strings="imageCustomStrings"
                    @change="onChangeImage('services')"
                    @ready="onReadyImage('services')"
                  >
                  </picture-input>
                </v-col>

                <v-col>
                  <p class="image_description">Scegli fra i predefiniti</p>
                  <ImagesStripeView
                    width="600px"
                    height="100px"
                    thumbWidth="100"
                    thumbHeight="100"
                    scope="services"
                    type="services"
                    style="border:1px solid #aaaaaa;"
                    @selected="imageSelected($event, 'services')"
                  />
                </v-col>
              </v-row>
              <v-btn
                v-if="!$store.state.editing"
                color="primary"
                @click="setContentsStep(6)"
              >
                PASSO SUCCESSIVO
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-step step="6" :editable="true" :complete="e6 > 6">
            Indirizzi
            <small>Scegli uno o più indirizzi dove ricevi i tuoi clienti</small>
          </v-stepper-step>
          <v-stepper-content class="vertical-stepper-content" step="6">
            <v-card color="#ffffff" class="ma-1 pb-2 elevation-4 card-contents">
              <v-row class="form-title" align="start" justify="center"
                ><v-col>
                  <div v-for="index in meta.number_of_addresses" :key="index">
                    <v-row class="form-title" align="center" justify="center"
                      ><v-col cols="11">
                        <v-col>
                          <v-text-field
                            v-model="meta['address_' + index + '_type']"
                            label="Tipologia Indirizzo"
                            required
                            outlined
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-text-field
                            v-model="meta['address_' + index + '_title']"
                            label="Titolo indirizzo"
                            required
                            outlined
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-text-field
                            v-model="meta['address_' + index + '_content']"
                            label="Indirizzo"
                            required
                            outlined
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-text-field
                            v-model="
                              meta['address_' + index + '_contact_phone']
                            "
                            label="Telefono"
                            required
                            outlined
                          >
                          </v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="
                              meta['address_' + index + '_contact_email']
                            "
                            label="E-Mail"
                            required
                            outlined
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-text-field
                            v-model="meta['address_' + index + '_hour_line1']"
                            label="Orario linea 1"
                            outlined
                          >
                          </v-text-field>
                        </v-col>

                        <v-col>
                          <v-text-field
                            v-model="meta['address_' + index + '_hour_line2']"
                            label="Orario linea 2"
                            outlined
                          >
                          </v-text-field>
                        </v-col>
                        <v-col>
                          <v-btn v-if="index != 1" icon>
                            <v-icon @click="removeAddress(index)" color="red"
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                          <v-btn icon v-if="index == meta.number_of_addresses">
                            <v-icon @click="addAddress()" color="green"
                              >mdi-plus</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-col>
                    </v-row>
                    <v-divider />
                  </div>
                </v-col>
              </v-row>

              <v-btn
                v-if="!$store.state.editing"
                color="primary"
                @click="setContentsStep(7)"
              >
                PASSO SUCCESSIVO
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-step step="7" :editable="true" :complete="e6 > 7">
            Social
            <small>Sei Social ? Configura i tuoi profili!</small>
          </v-stepper-step>

          <v-stepper-content class="vertical-stepper-content" step="7">
            <v-card color="#ffffff" class="ma-1 pb-2 elevation-4 card-contents">
              <v-row class="form-title" align="center" justify="center">
                <v-col>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors, valid }"
                    immediate
                  >
                    <div class="input-container d-flex align-center">
                      <v-text-field
                        v-model="meta.contact_email"
                        label="Inserisci qui la mail dove vuoi essere contattato dai clienti"
                        required
                        outlined
                        :error-messages="errors"
                        :success="valid"
                      >
                      </v-text-field>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            class="ml-2"
                            color="#74a2bc"
                            v-bind="attrs"
                            v-on="on"
                            slot="activator"
                            >mdi-information-outline</v-icon
                          ></template
                        >
                        <span
                          >Inserisci la mail dove vuoi ricevere le informazioni
                          degli utenti che compilano il modulo di contatto.<BR />Può
                          essere diversa dalle email che hai registrato con
                          noi!</span
                        >
                      </v-tooltip>
                    </div>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row class="form-title" align="center" justify="center"
                ><v-col>
                  <v-text-field
                    v-model="meta.facebook_link"
                    label="Indirizzo Facebook"
                    required
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="meta.twitter_link"
                    label="Indirizzo Twitter"
                    required
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="form-title" align="center" justify="center"
                ><v-col>
                  <v-text-field
                    v-model="meta.instagram_link"
                    label="Indirizzo Instagram"
                    required
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="meta.linkedin_link"
                    label="Indirizzo LinkedIn"
                    required
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row class="form-title" align="center" justify="center"
                ><v-col>
                  <v-text-field
                    v-model="meta.youtube_link"
                    label="Indirizzo YouTube"
                    required
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col> </v-col>
              </v-row>
              <v-btn
                v-if="
                  $store.state.wizard.meta.feature != 'premium' &&
                    $store.state.wizard.meta.feature != 'deluxe' &&
                    !$store.state.editing
                "
                color="primary"
                @click="configureContents($event)"
              >
                PASSO SUCCESSIVO
              </v-btn>

              <v-btn
                v-if="
                  ($store.state.wizard.meta.feature == 'premium' ||
                    $store.state.wizard.meta.feature == 'deluxe') &&
                    !$store.state.editing
                "
                color="primary"
                @click="setContentsStep(8)"
              >
                PASSO SUCCESSIVO
              </v-btn>
            </v-card>
          </v-stepper-content>

          <v-stepper-step
            v-if="
              (config.host == 'egyn' &&
                ($store.state.wizard.meta.feature == 'premium') ||
                $store.state.wizard.meta.feature == 'deluxe')
            "
            step="8"
            :editable="true"
            :complete="e6 > 8"
          >
            Blog
            <small
              >Configura gli articoli a disposizione che vuoi visualizzare sul
              tuo sito</small
            >
          </v-stepper-step>
          <v-stepper-content
            v-if="
              $store.state.wizard.meta.feature == 'premium' ||
                $store.state.wizard.meta.feature == 'deluxe'
            "
            class="vertical-stepper-content"
            step="8"
          >
            <v-card color="#ffffff" class="ma-1 pb-2 elevation-4 card-contents">
              <v-row class="form-title" align="center" justify="center">
                <v-col
                  ><h4>
                    Seleziona gli articoli che vuoi rendere disponibili nella
                    tua sezione Blog
                  </h4></v-col
                ></v-row
              >

              <v-card max-width="800" class="mx-auto ma-2" outlined>
                <v-card-text
                  v-for="s in articles"
                  :key="s.id"
                  class="article-card"
                >
                  <v-row
                    class="text-left article-row"
                    align="center"
                    justify="center"
                  >
                    <v-col>{{ s.title }}</v-col
                    ><v-col style="max-width: 40px"
                      ><v-checkbox
                        v-model="s.checked"
                        class="article-check text-right"
                        hide-details
                    /></v-col>
                  </v-row>
                  <v-row
                    dense
                    class="text-left article-description"
                    align="center"
                    justify="center"
                  >
                    <v-col>{{ s.description }} </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-btn color="primary" @click="setContentsStep(1)">
                TORNA ALL' INIZIO
              </v-btn>

              <v-btn
                v-if="!contentsProvided"
                class="ml-2"
                @click="configureContents($event)"
                color="primary"
              >
                Passo successivo
              </v-btn>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </v-col>
    </v-row>

    <div v-if="!loadingData" class="form-spacer" />

    <v-row
      v-if="!loadingData"
      class="text-center"
      align="center"
      justify="center"
    >
      <v-btn
        v-if="!contentsProvided && !this.$store.state.editing"
        class="ml-2"
        @click="goBack()"
        color="primary"
        >Indietro</v-btn
      >
      <v-btn
        v-if="!contentsProvided && !this.$store.state.editing"
        class="ml-2"
        @click="configureContents($event)"
        color="primary"
      >
        Passo successivo
      </v-btn>

      <v-btn
        class="ml-2"
        v-if="$store.state.editing"
        @click="configureContents($event)"
        color="primary"
      >
        Modifica servizi
      </v-btn>

      <v-progress-circular
        v-if="contentsProvided"
        :indeterminate="true"
        :rotate="0"
        :size="32"
        :width="4"
        color="light-blue"
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import mime from "mime";

import Vue from "vue";
import imageManager from "../../apis/images";
import wizardManager from "../../apis/wizard";
import store from "../../store/index";
import config from "../../config";
import services from "../../apis/services";
import PictureInput from "../ImageInput";
import ImagesStripeView from "../ImagesStripeView";
import messageBox from "../../components/MessageBox.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  data() {
    return {
      packets: [],
      e6: 1,
      articles: [],
      config: config,
      loadingData: true,
      contentsProvided: false,
      services: [],
      tab: null,
      meta: {},

      imageCustomStrings: {
        upload: "<p>La tua unità non supporta il caricamento dei files</p>", // HTML allowed
        drag: "Trascina un immagine o <br>fai click per selezionare un file", // HTML allowed
        tap: "Fat tap per selezionare una foto<br>dalla tua galleria", // HTML allowed
        fileSize: "Le dimensioni del file sono troppo grandi", // Text only
        fileType: "Questo tipo di file non è supportato. Solo PNG o JPEG.", // Text only
        aspect: "Landscape/Portrait", // Text only
      },

      logoCustomString: {
        upload: "<p>La tua unità non supporta il caricamento dei files</p>", // HTML allowed
        drag: "Il tuo logo qui", // HTML allowed
        tap: "Fat tap per selezionare una foto<br>dalla tua galleria", // HTML allowed
        fileSize: "Le dimensioni del file sono troppo grandi", // Text only
        fileType: "Questo tipo di file non è supportato. Solo PNG o JPEG.", // Text only
        aspect: "Landscape/Portrait", // Text only
      },

      slideCustomString: {
        upload: "<p>La tua unità non supporta il caricamento dei files</p>", // HTML allowed
        drag: "Fondo slide", // HTML allowed
        tap: "Fat tap per selezionare una foto<br>dalla tua galleria", // HTML allowed
        fileSize: "Le dimensioni del file sono troppo grandi", // Text only
        fileType: "Questo tipo di file non è supportato. Solo PNG o JPEG.", // Text only
        aspect: "Landscape/Portrait", // Text only
      },

      packCustomString: {
        upload: "<p>La tua unità non supporta il caricamento dei files</p>", // HTML allowed
        drag: "Immagine pacchetto", // HTML allowed
        tap: "Fat tap per selezionare una foto<br>dalla tua galleria", // HTML allowed
        fileSize: "Le dimensioni del file sono troppo grandi", // Text only
        fileType: "Questo tipo di file non è supportato. Solo PNG o JPEG.", // Text only
        aspect: "Landscape/Portrait", // Text only
      },
    };
  },

  components: {
    PictureInput,
    ImagesStripeView,
    messageBox,
    ValidationProvider,
    ValidationObserver,
  },

  mounted() {
    this.fetchMeta()
      .then(() => {
        this.packets = [];
        this.meta = { ...this.meta, ...this.$store.state.wizard.meta };
        for (let n = 0; n < this.meta.number_of_packets; n++) {
          this.packets.push(1);
        }

        let selected_articles = this.$store.state.wizard.meta
          ? this.$store.state.wizard.meta.articles
          : this.meta.articles;

        const articles_array = selected_articles
          ? selected_articles.split(",").map(Number)
          : [];

        services
          .fetchArticles()
          .then((res) => {
            this.articles = res.articles;
            for (let n = 0; n < this.articles.length; n++) {
              let article = this.articles[n];
              if (articles_array.includes(article.id)) article.checked = true;
              else article.checked = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  },

  computed: {},

  methods: {
    fetchMeta() {
      return new Promise((resolve, reject) => {
        this.loadingData = true;
        this.meta = {};
        wizardManager
          .fetchMeta()
          .then((res) => {
            for (let n = 0; n < res.length; n++) {
              this.meta[res[n].name] = res[n].value;
            }
            if (this.meta.packets)
              this.meta.packets = JSON.parse(this.meta.packets);
            this.loadingData = false;
            resolve();
          })
          .catch((err) => {
            console.log(err);
            this.loadingData = false;
            reject();
          });
      });
    },

    getArticles() {
      let articles_id = [];
      for (let n in this.articles) {
        let article = this.articles[n];
        if (article.checked) articles_id.push(article.id);
      }
      return articles_id.join(",");
    },

    setContentsStep(step) {
      if (!this.$store.state.editing) {
        this.contentsProvided = true;
        store
          .dispatch("setWizardSteps", {
            meta: this.meta,
            completedStep: this.$store.state.wizard.completedStep,
            selectedStep: this.$store.state.wizard.selectedStep,
          })
          .then(() => {
            this.contentsProvided = false;
            this.e6 = step;
          });
      } else {
        this.contentsProvided = true;
        store
          .dispatch("setEditingMeta", {
            meta: this.meta,
          })
          .then(() => {
            this.$router.push("/");
            this.contentsProvided = false;
          });
      }
    },

    configureContents() {
      if (!this.$store.state.editing) {
        this.contentsProvided = true;
        this.meta.articles = this.getArticles();
        let completedStep = this.$store.state.wizard.completedStep;
        if (completedStep < this.$store.state.wizard.selectedStep)
          completedStep = this.$store.state.wizard.selectedStep;
        store
          .dispatch("setWizardSteps", {
            completedStep: completedStep,
            selectedStep: this.$store.state.wizard.selectedStep + 1,
            meta: this.meta,
          })
          .then(() => {
            this.contentsProvided = false;
          });
      } else {
        this.contentsProvided = true;
        this.meta.articles = this.getArticles();
        store
          .dispatch("setEditingMeta", {
            meta: this.meta,
          })
          .then(() => {
            this.$router.push("/");
            this.contentsProvided = false;
          });
      }
    },

    goBack() {
      this.$store.state.wizard.selectedStep--;
    },

    onChangeImage(type) {
      let mime_type = mime.getType(this.$refs[type + "_selector"].file.name);
      let mime_extension = mime.getExtension(mime_type);

      imageManager
        .uploadPicture(
          this.$refs[type + "_selector"].image.replace(
            "data:" + mime_type + ";base64,",
            ""
          ),
          this.$store.state.wizard.build_state_id,
          type + "." + mime_extension
        )
        .then(() => {
          this.meta[type + "_image"] =
            this.$store.state.wizard.build_state_id +
            "/" +
            type +
            "." +
            mime_extension;
        })
        .catch((err) => console.log(err));
    },

    onReadyImage(type) {
      Vue.nextTick(() => {
        this.loadImage(type);
      });
    },

    showPreview() {
      if (!this.$store.state.editing) {
        this.contentsProvided = true;
        let completedStep = this.$store.state.wizard.completedStep;
        if (completedStep < this.$store.state.wizard.selectedStep)
          completedStep = this.$store.state.wizard.selectedStep;

        store
          .dispatch("setWizardSteps", {
            completedStep: completedStep,
            selectedStep: this.$store.state.wizard.selectedStep,
            meta: this.meta,
          })
          .then(() => {
            this.contentsProvided = false;
            let thisURl = window.location.origin;
            let url =
              thisURl +
              "/sites/" +
              config.appPath +
              "/" +
              this.meta.feature +
              "?s=" +
              this.$store.state.wizard.build_state_id;
            window.open(url.replace("/deluxe", "/premium"));
          });
      } else {
        let thisURl = window.location.origin;
        let url =
          thisURl +
          "/sites/" +
          config.appPath +
          "/" +
          this.meta.feature +
          "?s=" +
          this.$store.state.editing;
        window.open(url.replace("/deluxe", "/premium"));
      }
    },

    loadImage(type) {
      let imageFile = this.meta[type + "_image"];
      let mimetype = mime.getType(imageFile);
      if (mimetype) {
        imageManager
          .downloadLowResPicture(
            this.$store.state.wizard.build_state_id,
            imageFile
          )
          .then((res) => {
            let imageComponent = this.$refs[type + "_selector"];
            if (Array.isArray(imageComponent))
              imageComponent = imageComponent[0];
            if (imageComponent) {
              imageComponent.setImage(
                "data:" + mimetype + ";base64," + res.data
              );

              Vue.nextTick(() => {
                imageComponent.onResize();
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    imageSelected(event, type) {
      this.meta[type + "_image"] = "_builtin:" + event.path;
      this.loadImage(type);
    },

    removePacket(index) {
      this.$refs.msgBox
        .show(
          "Vuoi davvero confermare la cancellazione del pacchetto ?",
          "Conferma operazione"
        )
        .then(() => {
          for (let n = index + 1; n <= this.meta.number_of_packets; n++) {
            this.meta["pack_" + index - 1 + "_title"] = this.meta[
              "pack_" + index + "_title"
            ];
            this.meta["pack_" + index - 1 + "_text"] = this.meta[
              "pack_" + index + "_text"
            ];
            this.meta["pack_" + index - 1 + "_image"] = this.meta[
              "pack_" + index + "_image"
            ];
          }
          this.meta.number_of_packets--;
          this.packets.splice(-1, 1);
        })
        .catch(() => {});
    },

    addPacket() {
      this.meta.number_of_packets++;
      this.meta["pack_" + this.meta.number_of_packets + "_title"] = "Titolo";
      this.meta["pack_" + this.meta.number_of_packets + "_text"] = "Testo";
      this.meta["pack_" + this.meta.number_of_packets + "_image"] =
        "_builtin:PACKS/1.jpg";
      this.packets.push(1);
    },

    removeAddress(index) {
      this.$refs.msgBox
        .show(
          "Vuoi davvero confermare la cancellazione dell' indirizzo ?",
          "Conferma operazione"
        )
        .then(() => {
          for (let n = index + 1; n <= this.meta.number_of_addresses; n++) {
            this.meta["address_" + index - 1 + "_title"] = this.meta[
              "address_" + index + "_title"
            ];
            this.meta["address_" + index - 1 + "_type"] = this.meta[
              "address_" + index + "_type"
            ];
            this.meta["address_" + index - 1 + "_content"] = this.meta[
              "address_" + index + "_content"
            ];
            this.meta["address_" + index - 1 + "_contact_phone"] = this.meta[
              "address_" + index + "_contact_phone"
            ];
            this.meta["address_" + index - 1 + "_contact_email"] = this.meta[
              "address_" + index + "_contact_email"
            ];
            this.meta["address_" + index - 1 + "_hour_line1"] = this.meta[
              "address_" + index + "_hour_line1"
            ];
            this.meta["address_" + index - 1 + "_hour_line2"] = this.meta[
              "address_" + index + "_hour_line2"
            ];
          }
          this.meta.number_of_addresses--;
        })
        .catch(() => {});
    },

    addAddress() {
      this.meta.number_of_addresses++;
      this.meta["address_" + this.meta.number_of_addresses + "_type"] =
        "Studio";
      this.meta["address_" + this.meta.number_of_addresses + "_title"] =
        "Villa massima";
      this.meta["address_" + this.meta.number_of_addresses + "_content"] =
        "Via del corso, 32 Roma, RM Italia";
      this.meta["address_" + this.meta.number_of_addresses + "_contact_phone"] =
        "+39 00 00 00 00";
      this.meta["address_" + this.meta.number_of_addresses + "_contact_email"] =
        "info@dottrossi.it";
      this.meta["address_" + this.meta.number_of_addresses + "_hour_line1"] =
        "Lunedì al Venerdì 8:00 - 17:00";
      this.meta["address_" + this.meta.number_of_addresses + "_hour_line2"] =
        "Sabato, Domenica 9:00 - 19:00";
    },
  },
};
</script>

<style scoped>
.card-contents {
  border: 1px solid #74a2bc !Important;
}

.image_description {
  font-size: 14px;
}

.vertical-stepper-content {
  border-left: 1px solid #74a2bc !Important;
}

.header-title-h2 {
  color: #74a2bc;
  font-size: 32px;
  font-weight: 400;
}

.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.service-row {
  background-color: #f5f5f5;
  font-size: 18px;
  margin-left: 2px;
  margin-right: 2px;
}

.service-card {
  padding: 5px;
}

.form-spacer {
  height: 30px;
}

.service-check {
  margin-top: 0px;
  margin-bottom: 0px;
}

.hide {
  visibility: hidden !important;
  width: 0;
  height: 0;
}

.progress-profile-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;

  align-items: center;
  text-align: center;
  justify-content: center;
  width: 300px;
  height: 300px;
  margin: auto;
}

.side-stepper .v-stepper__step {
  align-items: flex-start;
}

.article-row {
  background-color: #b5c8e1;
  font-size: 18px;
  margin-left: 2px;
  margin-right: 2px;
}

.article-description {
  background-color: #fafafa;
  font-size: 14px;
  margin-left: 2px;
  margin-right: 2px;
  color: #aaaaaa;
}

.article-card {
  padding: 5px;
}

.article-check {
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>
